import React, { useState } from "react";
import { useSelector } from "react-redux";

export const CloseOrderForm = ({ onClose, onConfirm, order }) => {
  return (
    <div>
      <h2>Close Material Sourcing Announcement</h2>
      <p className=" mt-1 mb-1 ">
        Are you sure you want to close this material sourcing announcement? This
        will pause the announcement and no new pickups will be accepted.
      </p>
      <div className="flex gap-1">
        <button
          onClick={onConfirm}
          className="modal-button cercle-purple white-text"
        >
          Close Announcement
        </button>
        <button
          onClick={onClose}
          style={{
            backgroundColor: "#ccc",
          }}
          className="modal-button"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export const DeleteOrderForm = ({ onClose, onConfirm, order }) => {
  const { orderLoading } = useSelector((state) => state.pickups);

  return (
    <div>
      <h2>Delete Material Sourcing Announcement</h2>
      <p className=" mt-1 mb-1 ">
        Are you sure you want to delete this material sourcing announcement?
        This will remove the announcement and all associated pickups.
      </p>
      <div className="flex gap-1">
        <button
          onClick={onConfirm}
          className="modal-button red white-text"
          disabled={orderLoading}
        >
          {orderLoading ? "Deleting..." : "Delete Announcement"}
        </button>
        <button
          onClick={onClose}
          style={{
            backgroundColor: "#ccc",
          }}
          className="modal-button"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};
